import {
  useAddOnFilter,
  useCurrentWorkspace,
  useSetAddOnFilter,
} from '@gripp/shared-logic';
import {
  AddOnSearchInput,
  Colors,
  countFilters,
  FilterHeaders,
  SlideAction,
  useSlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { AddButton } from '../../shared/components/addButton/addButton';
import { ModalButton } from '../../shared/components/modalButton';
import { CreateAddonForm } from './createAddonForm';

export const AddOnsFilters = () => {
  const navigate = useNavigate();
  const { currentViewMode, onSlideChange } = useSlideLayout();
  const currentWorkspace = useCurrentWorkspace();

  const { data: addOnFilter } = useAddOnFilter();
  const { mutateAsync: setAddOnFilter } = useSetAddOnFilter();
  const filterCount = countFilters(addOnFilter);

  const onFilterNavigate = async () => {
    if (currentViewMode === ViewMode.SINGLE) {
      await onSlideChange(SlideAction.DUAL);
    }
    navigate('/add-ons/filters');
  };

  return (
    <View style={styles.filtersContainer}>
      <FilterHeaders
        currentSearchKeyword={addOnFilter?.keyword}
        searchComponent={<AddOnSearchInput />}
        onFilterPress={onFilterNavigate}
        onSearchClose={() => setAddOnFilter({ keyword: '' })}
        filterCount={filterCount}
        Routes={{}}
      />

      {currentWorkspace && (
        <ModalButton
          label=""
          customButton={(toggleVisibility) => (
            <AddButton onPress={() => toggleVisibility(true)} />
          )}
          modalComponent={({ onComplete }) => (
            <CreateAddonForm
              onComplete={onComplete}
              workspaceId={currentWorkspace.id}
            />
          )}
          containerStyle={styles.modalContainer}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 12,
  },
  modalContainer: {
    flex: 1,
    alignSelf: 'center',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: 560,
    maxHeight: 193,
    borderRadius: 12,
    backgroundColor: Colors.primaryGrayBackground,
    overflow: 'hidden',
  },
});
